export const PORTAL_HOST_ID = 'eliberty-portal';
export const PORTAL_INNER_ID = 'eliberty-portal-inner';

export const findModalPortal = (): HTMLElement | undefined => {
  const host = document.getElementById(PORTAL_HOST_ID);
  const shadowPortal = host?.shadowRoot?.getElementById(PORTAL_INNER_ID);
  return shadowPortal || document.getElementById(PORTAL_INNER_ID) || host || undefined;
};
